export default function GoalHit() {
  return (
    <div className="popupBg">
      <div className="popupDiv">
        <h3 className="popupHead">
          Congratulations on hitting your Daily Goal!
        </h3>
        <p className="goalHitSub">Come back tomorrow to feel better.</p>
        <img
          src="https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Smilies/Partying%20Face.png"
          alt="Partying Face"
          className="goalHitImg"
        />
      </div>
    </div>
  );
}
